import $ from 'jquery';
import React from 'react';

var ProductQuestion = React.createClass({
    change: function(e) {
        var value = e.target.value;
        this.setState({
            question: value,
            canSubmit: 0 < value.length,
            submitting: false,
            submitted: false,
            failed: false
        });
    },
    getInitialState: function() {
        return {question: '', canSubmit: false};
    },
    success: function() {
        this.setState({submitted: true, failed: false, submitting: false});
    },
    fail: function() {
        this.setState({submitted: false, failed: true, submitting: false});
    },
    submit: function() {
        if (!this.state.canSubmit) {
            return;
        }
        this.setState({submitting: true});
        var data = {
            product: this.props.product,
            question: this.state.question
        };
        $.post('/_ajax/webshop/tuotekysymys',  data)
        .success(this.success)
        .fail(this.fail);
    },
    render: function() {
        var btnClass = this.state.canSubmit? 'btn-red': 'disabled';
        if (this.state.submitting) {
            return (
                <div className="submitting"><i className="fa fa-spinner fa-spin"></i></div>
            );
        }
        else if (this.state.submitted) {
            return (
                <div className="submitted">Kiitos viestistäsi! Vastaamme mahdollisimman pian.</div>
            );
        } else if (this.state.failed) {
            return (
                <div className="failed">Viestin lähettäminen epäonnistui. Yritä myöhemmin uudelleen.</div>
            );
        } else {
            return (
                <form>
                    <textarea placeholder="Kysymys..." onChange={this.change}></textarea>
                    <button type="button" className={'btn ' + btnClass} onClick={this.submit}>Lähetä kysymys</button>
                </form>
            );
        }

    }
});

export default ProductQuestion;



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/product-question.js
 **/